import React from "react";
import { useSelector } from "react-redux";
import { Card, CardContent, Typography } from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { logger } from "../../utils/logger";

const ImportExcelCard = ({ title, content, onClick }) => {
  const { user } = useSelector((state) => state.auth);

  const handleClick = () => {
    logger.info("Import card clicked", {
      openedCard: title,
      username: user?.username,
      role: user?.role,
    });

    if (onClick) onClick();
  };
  return (
    <Card
      sx={{
          width: 220,
          height: 200,
          textAlign: "center",
          p: 2,
          boxShadow: 3,
          borderRadius: 2,
          "&:hover": { boxShadow: 6, backgroundColor: "#f5f5f5" },
        }}
      onClick={handleClick}
    >
      <CardContent sx={{ padding: "5px" }}>
        <CloudUploadIcon sx={{ fontSize: 40, color: "#1976d2" }} />
        <Typography
          variant="h6"
          sx={{
            fontSize: "0.9rem",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {title}
        </Typography>
        <Typography
          variant="body2"
          sx={{
            fontSize: "0.68rem",
            whiteSpace: "pre-wrap",
            textOverflow: "ellipsis",
          }}
        >
          {content}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default ImportExcelCard;
